export default {
  budget: 'Presupuesto',
  upTo: 'hasta {value}',
  restrictions: 'Restricciones',
  customizations: 'Personalizaciones',
  spendIn: 'Gasto en',
  and: 'y',
  predictedSales: '{kpi} proyectadas',
  runningSimulation: 'Ejecutando simulación...',
  createdBy: 'Creado por',
  on: 'el',
  modelVersion: 'Versión del modelo:',
  clone: 'Clonar',
  compare: 'Comparar',
  edit: 'Editar',
  delete: 'Eliminar',
  printJsonToConsole: 'Imprimir JSON en consola',
  viewMore: 'Ver más',
  warning: 'Advertencia',
  deletingSimulation: 'Eliminando la simulación:',
  cannotBeUndone: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  cancel: 'Cancelar',
  unrestricted: 'Sin restricciones',
  moreThan: 'Más de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exactamente',
  settings: 'Configuración',
  showToExternalUsers: 'Mostrar a usuarios externos',
  save: 'Guardar',
  noPreviewAvailable: 'Este modelo no tiene una vista previa combinada',
  noPreviewReasonOutputs: 'Sus resultados se reportan por separado para {outputs}, y esos KPI no se pueden sumar en una sola cifra o gráfico.',
  noPreviewReasonGeneric: 'Este modelo reporta cada KPI por separado, así que no se pueden sumar en una sola cifra o gráfico.',
  noPreviewViewMore: 'Haz clic en "Ver más" para revisar cada KPI por separado.',
  kpiWeighting: 'Ponderación de KPI',
  kpiAutoBalance: 'Auto-Balance',
  timeRestrictions: 'Restricciones de tiempo',
  allChannels: 'Todos los Canales',
  fullPeriod: 'Período Completo'
}
